"use client";

import * as Sentry from "@sentry/nextjs";
import { useEffect } from "react";

// Initialise Sentry here as a fallback — global-error renders in a minimal
// environment where instrumentation-client.ts may not have run yet.
// Sentry.init() is safe to call twice; it skips if already initialised.
Sentry.init({
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
  tunnel: "/api/sentry-tunnel",
});

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <html>
      <body className="flex min-h-screen items-center justify-center bg-slate-50">
        <div className="text-center">
          <h2 className="mb-2 text-xl font-semibold text-slate-800">
            Something went wrong
          </h2>
          <p className="mb-4 text-sm text-slate-500">
            We&apos;ve been notified and are looking into it.
          </p>
          <button
            onClick={reset}
            className="rounded-lg bg-emerald-600 px-4 py-2 text-sm font-medium text-white hover:bg-emerald-700"
          >
            Try again
          </button>
        </div>
      </body>
    </html>
  );
}
